<template>
  <div class="m-list">
    <div class="width-a">
      <h1 class="title">教学管理</h1>
      <ul class="type">
        <template v-for="(item, index) in types">
          <li :class="typeIndex == index ? 'type-b' : 'type-a'" :key="item.typeId" @click="typeTap(index)">{{item.name}}
          </li>
        </template>
      </ul>
      <ul class="content">
        <!--<keep-alive></keep-alive>-->
        <router-view></router-view>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ManageStudy",
    data () {
      return {
        types: [
          {
            name: "直播课程",
            path: "/ManageStudy/StudentSchedule"
          },
          {
            name: "录播课程",
            path: "/ManageStudy/StudentCourse"
          },
          {
            name: "学习记录",
            path: "/ManageStudy/StudentRecord"
          },
          {
            name: "考核任务",
            path: "/ManageStudy/StudentAssessment"
          },
          {
            name: "考核成绩",
            path: "/ManageStudy/StudentAssessmentScore"
          },
          {
            name: "我的证书",
            path: "/ManageStudy/StudentCertificate"
          }
        ],
        typeIndex: 0
      }
    },
    methods: {
      typeTap (index) {
        this.typeIndex = index;
        let _path = this.types[index].path;
        this.$router.push({
          path: _path
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  .m-list {
    background-image: url("../../assets/bga01.png");
    background-repeat: no-repeat;
    min-height: 570px;
  }

  .title {
    font-size: 36px;
    font-weight: normal;
    color: #ffffff;
    text-align: center;
    padding: 60px 0px 40px 0px;
  }

  .type {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .type-a {
      width: 140px;
      height: 46px;
      text-align: center;
      line-height: 46px;
      background-color: #395bcd;
      color: #ffffff;
      font-size: 16px;
      margin: 0px 16px;
      cursor: pointer;
    }

    .type-b {
      width: 140px;
      height: 46px;
      text-align: center;
      line-height: 46px;
      background-color: #253b85;
      color: #ffffff;
      font-size: 16px;
      margin: 0px 16px;
      cursor: pointer;
    }
  }

  .content {
    padding: 60px 60px 60px 60px;
    margin-top: 60px;
    background-color: #ffffff;
  }
</style>